import { apiSlice } from "../../Api/apiSlice";

const videosApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get all videos records
    getVideos: builder.query({
      query: () => "/videos",
    }),
    // Get one specific video record
    getVideo: builder.query({
      query: (vId) => `/videos/${vId}`,
    }),
    // Add new video
    addVideo: builder.mutation({
      query: (data) => ({
        url: "/videos",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            videosApi.util.updateQueryData("getVideos", undefined, (draft) => {
              draft.push(data);
            })
          );
        } catch (error) {
          console.log("Video Fetch Error: ", error.message);
        }
      },
    }),
    // Edit video
    editVideo: builder.mutation({
      query: ({ data, id }) => ({
        url: `/videos/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, arg) => [{ type: "video", id: arg.id }],
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            videosApi.util.updateQueryData("getVideos", undefined, (draft) => {
              const vdo = draft.find((v) => v.id == data.id);
              Object.assign(vdo, { ...data });
            })
          );
        } catch (error) {
          console.log("Error video edit::", error.message);
        }
      },
    }),
    // Delete Video
    deleteVideo: builder.mutation({
      query: (vId) => ({
        url: `/videos/${vId}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // Optimistic cache update Start
        const patchResult = dispatch(
          videosApi.util.updateQueryData("getVideos", undefined, (draft) => {
            return (draft = draft.filter((v) => v.id != arg));
          })
        );
        queryFulfilled.catch(patchResult.undo);
        // Optimistic cache update End
      },
    }),
  }),
});

export const {
  useGetVideosQuery,
  useGetVideoQuery,
  useAddVideoMutation,
  useEditVideoMutation,
  useDeleteVideoMutation,
} = videosApi;
